<template>
  <div>
    <v-app class="p-4">
      <!--      start edit mode -->
      <template>
        <v-row justify="center">
          <v-dialog
              v-model="editModal"
              hide-overlay
              width="600px"
              height="300px"
              transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar
                  flat
                  dark
                  color="primary"
              >

                <v-toolbar-title>ویرایش متن</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn
                      icon
                      dark
                      @click="editModal = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <create-default-text :editProps="editProps"></create-default-text>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!--      end edit mode -->
      <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
        <div class="mt-5 pt-5">
          <router-link to="/Tools/defaultText" v-status="'defaultText_list'">
            <v-btn class="mt-5 btn-add-with-text">
              <span class="fa fa-plus ml-1"></span>
              افزودن متن پیشفرض
            </v-btn>
          </router-link>
          <v-card :loading="loading" class="p-3 pt-0">


            <terminal-table :currentPage="datas.current_page"
                            :perPage="datas.per_page" v-if="isMobile" :getData="getDataForTable"
                            :pageCount="datas.last_page"
                            :options="tableProps" :datas="datas" :headers="columns"></terminal-table>

            <data-table
                :data="datas"
                :columns="columns"
                :debounce-delay="3000"
                :translate="translate"
                :orderBy="tableProps.column"
                :pagination="paginate"
                :orderDir="tableProps.dir"
                :per-page="[10, 25, 50, 100, 500]"
                @on-table-props-changed="reloadTable"
                class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
            >
              <template slot="filters" slot-scope="{ tableFilters, perPage }">
                <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"
                               v-model="searchBox"></filters-table>
              </template>
            </data-table>
          </v-card>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import button from "@/view/pages/button";
import {Bus, dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import Swal from "sweetalert2";
import CreateDefault from "@/view/pages/ads/default/createDefault";
import createDefaultText from "@/view/pages/ads/default/createDefaultText";
import {debounce} from "../../../../custom";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "deafultAdsList",
  components: {FiltersTable, CreateDefault, TitleRibbon, button, dataTableProps, createTarefe, createDefaultText},
  props: {
    editProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tarafeName: "",
      editModal: false,
      loading: false,
      translates: [],
      datas: {},
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      url: `${url}/default/text`,
      selectedNumber: [],
      dataId: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.datas.current_page - 1;
            row = row * this.datas.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'دسته بندی',
          name: 'data.category',
          transform(val) {
            return `${val.data.data.category}`
          },
          primary: true,
          orderable: true,
          searchable: true,
        },
        {
          label: 'موضوع',
          name: 'data.title',
          transform(val) {
            return `${val.data.data.title}`
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            permission_prefix: 'notification_',
            buttons: [
              {
                name: 'edit',
                label: 'ویرایش',
                icon: 'pencil-alt',
                class: 'btn-outline-warning',
                action: this.actions,

              },
              {
                name: 'delete',
                label: 'حذف',
                icon: 'trash-alt',
                class: 'btn-outline-danger',
                action: this.actions,
              },
            ]
          }
        }
      ],
      searchBox: {
        search: '',
        length: 10
      },
    }
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      this.loading = true
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: query,
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: (data) => {
          this.datas = data;
          this.loading = false
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 1000);
    },
    actions(data, type) {
      if (type === 'edit') {
        this.editModal = true
        $.ajax({
          url: `${url}/default/${data.id}`,
          type: "GET",
          fn: this.actions,
          params: [data, type],
          headers: {
            Authorization: Token,
            ACCEPT: "application/json"
          },
          success: (data) => {
            this.editProps = {
              id: data.data.id,
              category: data.data.data.category,
              title: data.data.data.title,
              description: data.data.data.description
            }
          }

        });
      } else if (type === 'delete') {
        this.$modal.yesNo('تایید حذف', 'آیا از حذف این دسته اطمینان دارید؟', "neg", '').then((value => {
          if (value === true) {
            $.ajax({
              url: `${url}/default/${data.id}`,
              type: "DELETE",
              fn: this.actions,
              msg: true,
              params: [data, type],
              headers: {
                ACCEPT: "application/json",
                Authorization: Token
              },
              success: (data) => {
                this.reloadTable();
              }
            });
          }
        }))
      }
    }
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url);
    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    });
    Bus.$on('reload', () => {
      this.reloadTable()
    });
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>